export const BOLIVIA_TIME_ZONE = "America/La_Paz";

const boliviaDateParts = (value = new Date()) => {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: BOLIVIA_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  return Object.fromEntries(
    formatter.formatToParts(value)
      .filter((part) => part.type !== "literal")
      .map((part) => [part.type, part.value]),
  );
};

export const boliviaTodayInput = () => {
  const parts = boliviaDateParts();
  return `${parts.year}-${parts.month}-${parts.day}`;
};

export const boliviaDateInputWithOffset = (days) => {
  const parts = boliviaDateParts();
  const date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};

export const boliviaMonthStartInput = () => {
  const parts = boliviaDateParts();
  return `${parts.year}-${parts.month}-01`;
};

export const formatBoliviaDate = (value) => {
  if (!value) return "—";
  return new Intl.DateTimeFormat("es-BO", {
    timeZone: BOLIVIA_TIME_ZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(value));
};

export const formatBoliviaDateTime = (value) => {
  if (!value) return "—";
  return new Intl.DateTimeFormat("es-BO", {
    timeZone: BOLIVIA_TIME_ZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(new Date(value));
};